import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import { getAuthToken } from './lib/auth';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(() => !!getAuthToken());

  useEffect(() => {
    setIsAuthenticated(!!getAuthToken());
  }, []);

  const handleLogin = (success: boolean) => {
    setIsAuthenticated(success);
  };

  return (
    <Router>
      <div className="min-h-screen bg-secondary-50">
        <Routes>
          <Route 
            path="/login" 
            element={
              isAuthenticated ? 
              <Navigate to="/dashboard" replace /> : 
              <Login onLogin={handleLogin} />
            } 
          />
          <Route 
            path="/dashboard" 
            element={
              isAuthenticated ? 
              <Dashboard /> : 
              <Navigate to="/login" replace />
            } 
          />
          <Route 
            path="/" 
            element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} replace />} 
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;

